(() => {
 const dialog = document.querySelector('[data-cookie-dialog]');
 if (!dialog) return;
 const form = dialog.querySelector('form');
 const fieldset = form.querySelector('fieldset');
 const status = dialog.querySelector('[data-cookie-status]');
 let trigger;
 let api;
 let pending;
 function loadPrivacy() {
  if (window.Shopify?.customerPrivacy) return Promise.resolve(window.Shopify.customerPrivacy);
  if (pending) return pending;
  pending = new Promise((resolve, reject) => {
   if (!window.Shopify?.loadFeatures) { reject(new Error('Shopify unavailable')); return; }
   const timeout = setTimeout(() => reject(new Error('Privacy API timeout')), 10000);
   window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}], error => {
    clearTimeout(timeout);
    if (error || !window.Shopify.customerPrivacy) reject(error || new Error('Privacy API unavailable'));
    else resolve(window.Shopify.customerPrivacy);
   });
  }).catch(error => { pending = null; throw error; });
  return pending;
 }
 async function open(button) {
  trigger = button;
  // Use the platform's own preferences when configured; retain the API-backed
  // theme dialog as a fallback. Never set consent just by opening either panel.
  if (typeof window.privacyBanner?.showPreferences === 'function') {
   try {
    await window.privacyBanner.showPreferences();
    return;
   } catch { /* Keep preferences accessible if Shopify's banner is unavailable. */ }
  }
  if (!dialog.open) dialog.showModal();
  status.textContent = dialog.dataset.cookieLoading;
  fieldset.disabled = true;
  try {
   api = await loadPrivacy();
   const consent = api.currentVisitorConsent();
   for (const key of ['analytics','marketing','preferences']) form.elements[key].checked = consent[key] === 'yes';
   fieldset.disabled = false;
   status.textContent = '';
  } catch { status.textContent = dialog.dataset.cookieError; }
 }
 async function save(rejectAll) {
  if (!api || fieldset.disabled) return;
  fieldset.disabled = true;
  const choices = Object.fromEntries(['analytics','marketing','preferences'].map(key => [key,!rejectAll && form.elements[key].checked]));
  try {
   await new Promise((resolve,reject) => {
    const timeout = setTimeout(() => reject(new Error('Consent save timeout')),10000);
    api.setTrackingConsent(choices,() => { clearTimeout(timeout);resolve(); });
   });
   const saved = api.currentVisitorConsent();
   if (!Object.entries(choices).every(([key,value]) => saved[key] === (value ? 'yes' : 'no'))) throw new Error('Consent not persisted');
   if (rejectAll) for (const key of Object.keys(choices)) form.elements[key].checked = false;
   status.textContent = dialog.dataset.cookieSaved;
  } catch { status.textContent = dialog.dataset.cookieError; }
  finally { fieldset.disabled = false; }
 }
 document.addEventListener('click',event => {
  if (!(event.target instanceof Element)) return;
  const button = event.target.closest('[data-cookie-preferences]');
  if (button) { event.preventDefault();open(button); }
 });
 dialog.querySelector('[data-cookie-close]').addEventListener('click',() => dialog.close());
 dialog.addEventListener('close',() => trigger?.focus());
 form.addEventListener('submit',event => { event.preventDefault();save(false); });
 dialog.querySelector('[data-cookie-reject]').addEventListener('click',() => save(true));
})();

